module.exports = { id: "info", url: "/build/app/img/symbols.svg#info", viewBox: "", toString: function() { return this.url; } };